import React from 'react';
import { Row, Col, Collapse, Typography } from 'antd';

const { Panel } = Collapse;
const { Title, Paragraph } = Typography;

const FAQSection = ({ data }) => {
  return (
    <Row gutter={[0, 16]} justify="center" style={{ marginBottom: 200 }}>
      <Col xs={0} md={5} lg={6}></Col>
      <Col
        xs={24}
        md={14}
        lg={12}
        style={{ fontSize: '14px', marginTop: '16px', fontWeight: 500 }}
        className="padMobile"
      >
        <Title level={2}>Frequently Asked Questions</Title>
        <Collapse accordion>
          {data.map((faq, index) => (
            <Panel header={faq.question} key={index + 1}>
              <Paragraph>{faq.answer}</Paragraph>
            </Panel>
          ))}
        </Collapse>
      </Col>
      <Col xs={0} md={5} lg={6}></Col>
    </Row>
  );
};

export default FAQSection;
